module.exports = __webpack_public_path__ + "img/success.d9722ea3.svg";